export default {
  singleReceipt: {},
  singleReceipts: [],
  singleReceiptsGrid: {
    data: [],
    total: 0
  }
}
